"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwentyOneScoring = void 0;
const logic_metrics_1 = require("./logic-metrics");
const logic_types_1 = require("./logic-types");
class TwentyOneScoring {
    static hasReachedTargetScore(score) {
        const finalScore = score.maxScore <= logic_metrics_1.LogicMetrics.TargetScore
            ? score.maxScore
            : score.minScore;
        return finalScore === logic_metrics_1.LogicMetrics.TargetScore;
    }
    static hasBust(score) {
        return (score.maxScore > logic_metrics_1.LogicMetrics.TargetScore &&
            score.minScore > logic_metrics_1.LogicMetrics.TargetScore);
    }
    static displayScore(score) {
        if (score.maxScore > logic_metrics_1.LogicMetrics.TargetScore) {
            return `${score.minScore}`;
        }
        return score.minScore === score.maxScore ||
            score.maxScore === logic_metrics_1.LogicMetrics.TargetScore
            ? `${score.maxScore}`
            : `${score.minScore}/${score.maxScore}`;
    }
    static calculateScore(cards) {
        var _a, _b, _c, _d, _e;
        let minScore = 0;
        let maxScore = 0;
        const faceUpCards = cards
            .filter((card) => card.isFaceUp)
            .sort((a, b) => { var _a, _b, _c, _d; return ((_b = (_a = b.cardId) === null || _a === void 0 ? void 0 : _a.cardType) !== null && _b !== void 0 ? _b : 0) - ((_d = (_c = a.cardId) === null || _c === void 0 ? void 0 : _c.cardType) !== null && _d !== void 0 ? _d : 0); });
        if (faceUpCards.some((card) => { var _a; return (_a = card.cardId) === null || _a === void 0 ? void 0 : _a.isWild; })) {
            return {
                minScore: logic_metrics_1.LogicMetrics.TargetScore,
                maxScore: logic_metrics_1.LogicMetrics.TargetScore,
            };
        }
        for (const card of faceUpCards) {
            minScore += (_b = (_a = card.cardId) === null || _a === void 0 ? void 0 : _a.blackjackValue.minValue) !== null && _b !== void 0 ? _b : 0;
            maxScore += (_d = (_c = card.cardId) === null || _c === void 0 ? void 0 : _c.blackjackValue.maxValue) !== null && _d !== void 0 ? _d : 0;
        }
        for (const card of faceUpCards) {
            if (((_e = card.cardId) === null || _e === void 0 ? void 0 : _e.cardType) === logic_types_1.CardType.Ace &&
                maxScore > logic_metrics_1.LogicMetrics.TargetScore) {
                const value = card.cardId.blackjackValue;
                maxScore -= value.maxValue;
                maxScore += value.minValue;
            }
        }
        return { minScore, maxScore };
    }
}
exports.TwentyOneScoring = TwentyOneScoring;
